  <template>
      <div class="body">
          <p  class="font1" style="padding-top: 13vh;">千淘万沥虽辛苦</p>
          <p  class="font1" style="padding-top: 1vh;">吹进狂沙始到金</p>

          <div style="width: 80%;margin: 0 auto;margin-top: 3vh;">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">2024年必修课程：</p>
            <ul>
                    <li>《反贪腐（风清气正）2024》</li>
                    <li>《行为准则（COC）简介-2024》</li>
                </ul>
            <p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
          </div>

          <div style="margin-top: 3vh;" v-if="grade=== '师4'">
              <p style="width: 80%;margin: 0 auto; font-size: 20px;color: #000;">晋升<a style="font-size: 25px;color: #953b5d;">{{grade}}</a>必修课程完成情况：</p>
              <div style="display: flex;width:90%;margin:0 auto;justify-content: center;background-color: rgb(226, 145, 226,0.3);">
                <div style="width: 30%;text-align: center;">
                  <p style="margin:0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreC}}</a>/30.5</p>
                  <p style="margin: 0;color: #000;">必修学分</p>
                </div>
                <div style="width: 30%;text-align: center;">
                  <p style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreE}}</a>/8</p>
                  <p style="margin: 0;color: #000;">选修学分</p>
                </div>
                <div style="width: 30%;text-align: center;">
                  <p v-if="this.status ===true" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-check" style="color:#953b5d;"></i></p>
                  <p v-if="this.status ===false" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-times" style="color:#953b5d;"></i></p>
                  <p style="margin: 0;color: #000e;">达标状态</p>
                </div>
              </div>
          </div>
          <div style="margin-top: 3vh;" v-if="this.grade=== '师8'">
              <p style="width: 80%;margin: 0 auto; font-size: 20px;color: #000;">晋升<a style="font-size: 25px;color: #953b5d;">{{this.grade}}</a>必修课程完成情况：</p>
              <div style="display: flex;width:90%;margin:0 auto;justify-content: center;background-color: rgb(226, 145, 226,0.3);">
                <div style="width: 30%;text-align: center;">
                  <p style="margin:0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreC}}</a>/51.5</p>
                  <p style="margin: 0;color: #000;">必修学分</p>
                </div>
                <div style="width: 30%;text-align: center;">
                  <p style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreE}}</a>/8</p>
                  <p style="margin: 0;color: #000;">选修学分</p>
                </div>
                <div style="width: 30%;text-align: center;">
                  <p v-if="this.status ===true" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-check" style="color:#953b5d;"></i></p>
                  <p v-if="this.status ===false" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-times" style="color:#953b5d;"></i></p>
                  <p style="margin: 0;color: #000e;">达标状态</p>
                </div>
              </div>
          </div>
          <p v-if="ReportData.status!== null" style="width: 80%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;">**具体可登录富学宝典查看:【首页】>【个人设置】>【晋升课程】**</p>
         
      </div>
  </template>
  
  <script>
  export default {
    props: ["ReportData"],
    components: {
     
    },
    data() {
      return {
          grade:'',
          scoreC:'',
          scoreE:'',
          status:''
      }
    }, 
    created(){
      const status=JSON.parse(this.ReportData.status)
      if(status !== null){
        this.grade=status[0].grade
        this.scoreC=status[0].C
        this.scoreE=status[0].E
        this.status=status[0].status
      }
    },
    computed:{
      
    },
    mounted(){
      
    }
  }
  </script>
  
  <style scoped>
  .body {
    background: url("../../assets/24January/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24January/logo2.png") right  top  no-repeat,
                url("../../assets/24January/bg6.jpg")  no-repeat;
    background-size: 17% 8%,117px 50px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 80%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  </style>